import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";

export default function ServicesHeader({ title, selectedServices = 0, totalServices = 0 }) {
  return (
    <div className="flex flex-col gap-1">
      <Typography className="text-[20px] font-semibold" style={{ color: HNSColors.neutrals[100] }}>
        {title}
      </Typography>
      <Typography
        className="text-[14px]"
        style={{ color: HNSColors.neutrals[600] }}
      >{`${selectedServices}/${totalServices} Selected`}</Typography>
    </div>
  );
}
